import React, { useState, useRef, useEffect, useCallback, useContext, useLayoutEffect } from 'react'
// import { usePopupContext } from '../../shared/contexts/popupclose-context'
import { PopupCloseContext, UserInitalValue } from '../../store/contexts/popupclose-context'
import './popup.css'
interface PopupProps {
  buttonRef?: React.RefObject<HTMLButtonElement | null>;
  ref?: React.RefObject<HTMLButtonElement>
  popupId?: string;
  options?: any;
  content?: any;
  onSelect?: any;
  targetRef?: any;
  onClose?: any;
  className?: any;
  popupContent?: any;
  setMultiplePopup?: (id: string | null) => void;
  popupHeaderClass?: any;
  popupTitle?: any
  popupHeaderClose?: any
  popupContentClass?: any
  popupActions?: any
  popupFooterClass?: any
  popupFooterCloseIcon?: any
  popupFooterClose?: any
  popuparrow?: any
  closebtnclass?: any
  onClick?: any
  fixedpopup?:any
  onPositionChange?: (top: number) => void;
  popupclosebtnclassName?:string
}

const Popups: React.FC<PopupProps> = ({ buttonRef, popupId, className, fixedpopup, popupHeaderClass, popupTitle, popupHeaderClose, popupContent, popupContentClass, closebtnclass, popupActions, popupFooterClass, popupFooterCloseIcon, popupFooterClose, onPositionChange, popuparrow,popupclosebtnclassName }) => {
  const { multiplePopup, setMultiplePopup }: typeof UserInitalValue = useContext(PopupCloseContext)
  const [popupPosition, setPopupPosition] = useState<{ top: number; left: number; fixedTop:number; fixedLeft:number; maxHeight: any; arrowtop: any; arrowleft: any }>({ top: 0,left: 0, fixedTop:0, fixedLeft:0, maxHeight: 0, arrowtop: 0, arrowleft: 0 })
  const popupRef = useRef<HTMLDivElement>(null)
  const [isVisible, setIsVisible] = useState(false)
  const wrapperRef = useRef<HTMLElement | null>(document.getElementById('wrapper'))
  //...Popup tab focus//
  const headingpopupRef = useRef<HTMLHeadingElement | null>(null)
  useLayoutEffect(() => {
  const handleTabKey = (e: KeyboardEvent) => {
    if (e.key !== 'Tab' || !popupRef.current) return

    const focusableElements = Array.from(
      popupRef.current.querySelectorAll<HTMLElement>(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(el => el.offsetParent !== null)

    if (focusableElements.length === 0) return

    const firstElement = focusableElements[0]
    const lastElement = focusableElements[focusableElements.length - 1]

    if (e.shiftKey && document.activeElement === firstElement) {
      e.preventDefault()
      lastElement.focus()
    } else if (!e.shiftKey && document.activeElement === lastElement) {
      e.preventDefault()
      firstElement.focus()
    }
  }
  document.addEventListener('keydown', handleTabKey)
  return () => {
    document.removeEventListener('keydown', handleTabKey)
  }
}, [])


  const updatePopupPosition = useCallback(() => {
    if (buttonRef?.current && popupRef.current) {
      const buttonRect = buttonRef.current.getBoundingClientRect()
      const parentDiv = buttonRef.current.offsetParent as HTMLElement
      const parentRect = parentDiv?.getBoundingClientRect()
      const popupRect = popupRef.current.getBoundingClientRect()
  
      let top = buttonRect.bottom - (parentRect?.top || 0) // Default to below the button
      let left = buttonRect.left - (parentRect?.left || 0) // Align left with button
      
      let fixedTop = buttonRect.bottom // Default to below the button
      let fixedLeft = buttonRect.left // Align left with button
      let maxHeight = 0
      let arrowtop = buttonRect.bottom - (parentRect?.top || 0) // Default arrow position
      const arrowleft = buttonRect.left - (parentRect?.left || 0) + buttonRect.width / 2 // Default arrow center
  
      const spaceBelow = window.innerHeight - buttonRect.bottom // Space below button
      const spaceAbove = buttonRect.top - 156 // Space above button
      const spaceRight = window.innerWidth - buttonRect.right // Space to the right
      const spaceLeft = buttonRect.left // Space to the left
  
      // Determine if the popup should be above or below
      if (spaceBelow >= spaceAbove) {
        maxHeight = spaceBelow // Enough space below
      } else {
        top = buttonRect.top - popupRect.height - (parentRect?.top || 0) // Position above the button
        arrowtop = buttonRect.top - (parentRect?.top || 0)
        maxHeight = spaceAbove // Limit height to available space above
        fixedTop=buttonRect.top - popupRect.height
      }
      // Adjust for insufficient right space
      if (left + popupRect.width + (parentRect?.left || 0) > window.innerWidth) {
        if (spaceRight < popupRect.width && spaceLeft >= popupRect.width) {
          left = buttonRect.right - popupRect.width - (parentRect?.left || 0)
          fixedLeft = buttonRect.right - popupRect.width
        } else {
          left = window.innerWidth - popupRect.width - (parentRect?.left || 0)
          fixedLeft = window.innerWidth - popupRect.width
        }
      }
      
      if (popupRect.width > 700) {
        const parentWidth = parentRect?.width || 0
        const parentLeft = parentRect?.left || 0
        const buttonLeftInParent = buttonRect.left - popupRect.width - parentLeft + buttonRect.width

        const spaceLeftInParent = buttonLeftInParent
        const spaceRightInParent = parentWidth - (buttonLeftInParent + buttonRect.width)
        if (spaceLeftInParent >= 0 && spaceRightInParent >= popupRect.width - buttonRect.width) {          
          left = buttonLeftInParent
          fixedLeft = buttonRect.left
        } else {
          left = (parentWidth - popupRect.width) / 2
          fixedLeft = parentLeft + (parentWidth - popupRect.width) / 2
        }
      }
      const chatbot = document.querySelector('.ask-ai-chatbox.open') as HTMLElement | null
      if (chatbot && window.innerWidth > 2200) {
        const chatbotRect = chatbot.getBoundingClientRect()
        const gap = 40
        const viewportPadding = 16
        const maxFixedLeft = chatbotRect.left - popupRect.width - gap

        if (fixedLeft > maxFixedLeft) {
          fixedLeft = Math.max(viewportPadding, maxFixedLeft)
          left = fixedLeft - (parentRect?.left || 0)
        }
      }
      setPopupPosition({ top, left, fixedTop, fixedLeft, maxHeight, arrowtop, arrowleft })
  
      // Send the top position back to the parent component, if the callback exists
      if (onPositionChange) {
        onPositionChange(top)
      }
    }
  }, [buttonRef, onPositionChange])
  
  useEffect(() => {
    // Initial position calculation
    updatePopupPosition()
    

    // Recalculate position on window resize
    window.addEventListener('resize', updatePopupPosition)

    // Cleanup on unmount
    return () => {
      window.removeEventListener('resize', updatePopupPosition)
    }
  }, [updatePopupPosition])
  
  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      updatePopupPosition()
    })
    if (wrapperRef.current) {
      resizeObserver.observe(wrapperRef.current)
    }
    return () => {
      resizeObserver.disconnect()
    }
  }, [updatePopupPosition])

  useEffect(() => {
    setPopupPosition({ top: 0, left: 0, fixedTop:0, fixedLeft:0, maxHeight: 0, arrowtop: 0, arrowleft: 0 })
    setTimeout(() => {
      updatePopupPosition()
    }, 200)
  }, [updatePopupPosition])

  // Manage fade-in and fade-out transitions
  useEffect(() => {
    if (multiplePopup === popupId) {
      setIsVisible(true)
      updatePopupPosition()
      if (popupRef.current) {
        popupRef.current.scrollTop = 0
        popupRef.current.focus({ preventScroll: true })
        requestAnimationFrame(() => {
          const firstFocusable = popupRef.current?.querySelector<HTMLElement>(
            'input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]),[tabindex]:not([tabindex="-1"])'
          )
          firstFocusable?.focus({ preventScroll: true })
        })
      }
    } else if (isVisible) {
      setIsVisible(false)
    }
  }, [multiplePopup, popupId, isVisible, updatePopupPosition])
  
  if (!isVisible && multiplePopup !== popupId) return null

  return (
    <>
      {popuparrow &&
        <div
          style={{
            top: popupPosition.top >= 0 ? popupPosition.top : popupPosition.arrowtop - 8,
            left: popupPosition.arrowleft
          }}
          className={`arrow ${popupPosition.top >= 0 ? 'arrow-bottom' : 'arrow-top'}`}></div>
      }
        <div
          ref={popupRef}
          className={`${className} ${multiplePopup === popupId ? 'fade-in' : 'fade-out'}`}
          style={{
            position:fixedpopup ? 'fixed' : 'absolute',
            top: fixedpopup ? popupPosition.fixedTop : popuparrow ? (popupPosition.top >= 0 ? popupPosition.top + 8 : popupPosition.top - 8) : popupPosition.top-4,
            left:fixedpopup ? popupPosition.fixedLeft : popupPosition.left,
            maxHeight: popuparrow ? popupPosition.maxHeight - 8 : popupPosition.maxHeight, // Dynamically set max-height based on available space
          }}
          id={popupId}
          tabIndex={-1}
        >
          {(popupTitle || popupHeaderClose) && <div className={`d-flex ${popupHeaderClass}`}>
            <h1 tabIndex={0} aria-label={popupTitle} ref={headingpopupRef}>{popupTitle}</h1>
          </div>}
          {popupContent && <div className={popupContentClass}>
            {popupContent}
          </div>}
          {popupActions && <div className={popupFooterClass} >
            {popupActions}
            {popupFooterClose && <button className={popupFooterCloseIcon} title={popupFooterClose} onClick={() => setMultiplePopup(null)}><span className={closebtnclass}></span>{popupFooterClose}</button>}
          </div>}
          {popupHeaderClose && <button className={popupclosebtnclassName} onClick={() => setMultiplePopup(null)}><span className={closebtnclass}></span>{popupHeaderClose}</button>}
        </div>
    </>
  )
}

export default React.memo(Popups)